export default function isFirefox() {
  return (
    (window.navigator.userAgent.includes('Firefox') ||
      window.navigator.userAgent.includes('FxiOS') ||
      window.navigator.userAgent.includes('Mozilla')) &&
    !window.navigator.userAgent.includes('Chrome')
  );
}
